import { useState } from "react";
import { dismissMobileAppPromo, isMobileAppPromoDismissed } from "./mobileAppPromoDismiss";
import { MobileAppPromoCard } from "./MobileAppPromoCard";

/**
 * @param {React.ComponentProps<typeof MobileAppPromoCard>} props
 */
export function DismissibleMobileAppPromo(props) {
  const [visible, setVisible] = useState(() => !isMobileAppPromoDismissed());

  if (!visible) {
    return null;
  }

  return (
    <MobileAppPromoCard
      {...props}
      onDismiss={() => {
        dismissMobileAppPromo();
        setVisible(false);
      }}
    />
  );
}
